import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';

export function AdminSidebar() {
  const loc = useLocation();
  const { logout } = useAuth();
  const links = [
    { to:'/admin',               label:'Dashboard',    icon:'📊' },
    { to:'/admin/usuarios',      label:'Usuários',     icon:'👤' },
    { to:'/admin/assinaturas',   label:'Assinaturas',  icon:'💳' },
    { to:'/admin/veiculos',      label:'Veículos',     icon:'🚗' },
    { to:'/admin/veiculos/novo', label:'Novo veículo', icon:'➕' },
    { to:'/admin/solicitacoes',  label:'Solicitações', icon:'📋' },
    { to:'/admin/produto',       label:'Produto',      icon:'💧' },
    { to:'/admin/campanhas',     label:'Campanhas',    icon:'📢' },
  ];
  return (
    <div className="admin-sidebar">
      <div className="logo" style={{ padding:'24px 22px', borderBottom:'1px solid rgba(255,255,255,.08)' }}>
        <div className="logo-text">Heritage</div>
        <div className="logo-sub">Painel admin</div>
      </div>
      <ul className="admin-nav">
        {links.map(l => (
          <li key={l.to}>
            <Link to={l.to} className={loc.pathname === l.to ? 'ativo' : ''}>
              <span style={{ fontSize:15 }}>{l.icon}</span>{l.label}
            </Link>
          </li>
        ))}
        <li style={{ marginTop:16, paddingTop:16, borderTop:'1px solid rgba(255,255,255,.06)' }}>
          <button onClick={logout} style={{ background:'none', border:'none', cursor:'pointer', color:'rgba(255,255,255,.35)', padding:'10px 20px', width:'100%', textAlign:'left', fontSize:12, fontWeight:700, letterSpacing:.5, display:'flex', gap:10, alignItems:'center' }}>
            <span style={{ fontSize:15 }}>🚪</span>Sair
          </button>
        </li>
      </ul>
    </div>
  );
}

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get('/admin/dashboard').then(({ data }) => setStats(data)).catch(() => {}); }, []);

  const cards = stats ? [
    { label:'Usuários',          value:stats.total_usuarios,         icon:'👤', accent:'#2563eb' },
    { label:'Assinaturas ativas',value:stats.assinaturas_ativas,     icon:'💳', accent:'#1e7d47' },
    { label:'Em trial',          value:stats.em_trial ?? '—',        icon:'⏳', accent:'#d8bd69' },
    { label:'Veículos publicados',value:stats.veiculos_publicados,   icon:'🚗', accent:'var(--rust)' },
    { label:'Sol. pendentes',    value:stats.solicitacoes_pendentes, icon:'📋', accent:'#c85718' },
    { label:'Receita do mês',    value:`R$ ${Number(stats.receita_mes||0).toLocaleString('pt-BR')}`, icon:'💰', accent:'#7c3aed' },
  ] : [];

  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header">
          <h1 className="admin-title">Dashboard</h1>
          <span style={{ fontSize:13, color:'var(--ink-muted)' }}>{new Date().toLocaleDateString('pt-BR',{weekday:'long',year:'numeric',month:'long',day:'numeric'})}</span>
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:18, marginBottom:28 }}>
          {cards.map(c => (
            <div key={c.label} className="card" style={{ padding:24, borderLeft:`3px solid ${c.accent}` }}>
              <div style={{ fontSize:24, marginBottom:8 }}>{c.icon}</div>
              <div style={{ fontFamily:"'Playfair Display',serif", fontSize:28, fontWeight:600, color:c.accent }}>{c.value ?? '—'}</div>
              <div style={{ fontSize:10, color:'var(--ink-muted)', marginTop:4, letterSpacing:.5, textTransform:'uppercase' }}>{c.label}</div>
            </div>
          ))}
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:20 }}>
          <div className="card" style={{ padding:28 }}>
            <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:18, marginBottom:18 }}>Acesso rápido</h3>
            <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
              <Link to="/admin/solicitacoes?status=aguardando" className="btn btn-primary btn-sm" style={{ justifyContent:'center' }}>Ver solicitações pendentes</Link>
              <Link to="/admin/veiculos/novo" className="btn btn-outline btn-sm" style={{ justifyContent:'center' }}>Cadastrar novo veículo</Link>
              <Link to="/admin/campanhas" className="btn btn-outline btn-sm" style={{ justifyContent:'center' }}>Gerenciar campanhas</Link>
            </div>
          </div>
          <div className="card" style={{ padding:28 }}>
            <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:18, marginBottom:16 }}>Lembretes</h3>
            {['Nenhum anúncio é publicado automaticamente.','Analise cada solicitação antes de aprovar.','Usuários em trial têm acesso completo por 7 dias.','Mantenha campanhas de consórcio em destaque.'].map(t => (
              <p key={t} style={{ fontSize:13, color:'var(--ink-muted)', lineHeight:1.5, marginBottom:10, paddingLeft:12, borderLeft:'2px solid var(--border)' }}>{t}</p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
